import React from 'react';
import { Flame } from 'lucide-react';

const SCORE_ITEMS = [
  { label: 'Notes', key: 'notes', color: 'bg-blue-50 text-blue-700' },
  { label: 'Shares', key: 'shares', color: 'bg-violet-50 text-violet-700' },
  { label: 'Docs', key: 'documents', color: 'bg-emerald-50 text-emerald-700' },
  { label: 'Status', key: 'status', color: 'bg-amber-50 text-amber-700' },
  { label: 'Appts', key: 'appointments', color: 'bg-cyan-50 text-cyan-700' },
  { label: 'Recency', key: 'recency', color: 'bg-rose-50 text-rose-700' },
  { label: 'Hunter', key: 'hunter', color: 'bg-orange-50 text-orange-700' },
];

const LABEL_CLASS = {
  hot: 'bg-red-100 text-red-700',
  warm: 'bg-amber-100 text-amber-700',
};
const DEFAULT_LABEL_CLASS = 'bg-slate-100 text-slate-600';

const FLAME_CLASS = {
  hot: 'text-red-500',
  warm: 'text-amber-500',
};
const DEFAULT_FLAME_CLASS = 'text-slate-400';

export function LeadScoreCard({ score }) {
  if (!score) return null;

  const labelCls = LABEL_CLASS[score.label] || DEFAULT_LABEL_CLASS;
  const flameCls = FLAME_CLASS[score.label] || DEFAULT_FLAME_CLASS;

  return (
    <div className="border border-slate-200 rounded-sm bg-white p-5" data-testid="lead-score-badge">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Flame className={`w-4 h-4 ${flameCls}`} />
          <h2 className="font-heading font-semibold text-slate-900 text-sm">Lead Score</h2>
        </div>
        <span className={`inline-flex items-center gap-1 text-sm font-bold px-3 py-1 rounded-sm ${labelCls}`} data-testid="lead-score-total">
          {score.label === 'hot' && <Flame className="w-3.5 h-3.5" />}
          {score.total} pts &middot; {score.label.charAt(0).toUpperCase() + score.label.slice(1)}
        </span>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
        {SCORE_ITEMS.map(item => {
          const v = score.breakdown?.[item.key];
          return (
            <div key={item.key} className={`p-2 rounded-sm text-center ${item.color}`} data-testid={`score-${item.label.toLowerCase()}`}>
              <p className="text-lg font-bold">{typeof v === 'number' ? v : 0}</p>
              <p className="text-[10px] uppercase tracking-wide font-medium opacity-80">{item.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
